import { Search, Edit, Check, Comment } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Button, Card, CardContent, Chip, GridLegacy as Grid, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel,InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, DialogType, FormActions, usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../components/form/ModalForm";




const schema = yup.object({
  estado_caso: yup.string().required(),
  respuesta: yup.string().required(),
}).required();

const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const GestionCasos = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...usuarioEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [roles,setRoles] = useState([]);
  const [companiasList,setCompaniasList] = useState([]);
  const [productosOptions,setProductosOptions] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [clienteOptions,setClienteOptions] = useState([]);
  const [agentesOptions,setAgentesOptions] = useState([]);
  const [centrosOp,setCentrosOp] = useState([]);
  const [centrosOpDestino,setCentrosOpDestino] = useState([]);
  const [compradores,setCompradores] = useState([]);
  



    useEffect(()=>{

      
      loadInitData();
      listarCompradores();
    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    

    const listarCompradores = async(search)=>{
      let {data:{value:{data}}} = await AxiosInstance.get("maestros/listar-compradores");
      setCompradores([...compradores]);
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("auditoria/consultar-casos",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value?.data]);

     setTotalRows(value?.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (info)=>{
      setIsVisibleModalDetalle(true);
   
     
      setProductoSeleccionado({...info});
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);
    
    }

    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
      const urlService = "auditoria/actualizar-estado-proyecto";
 
        let payload = {
          caso_id:dataForm.caso_id,
          respuesta:dataForm.respuesta,
          estado_caso:dataForm.estado_caso
        };
      

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }





   const getCestaColor = status=>{
    if (status === 'ABIERTO'){
      return "primary";
    }
    if (status === 'CERRADO'){
      return "success";
    }
    return "default";
  }

    const columnsTable = [
      {
      
       key:"caso_id",
       keyValue:"caso_id",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"orden_compra_id",
        keyValue:"orden_compra_id",
        label:"# de orden de compra",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
      {
      
        key:"comprador_nombre",
        keyValue:"comprador_nombre",
        label:"Comprador",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Card>
          <CardContent>
            <Typography variant="subtitle1" >{props.value}</Typography>
            <Typography variant="subtitle2" >CEL: {props.info.comprador_celular}</Typography>
          </CardContent>
        </Card>,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"descripcion_caso",
        keyValue:"descripcion_caso",
        label:"Descripcion del caso",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Card>
          <CardContent>
              {props.value}
          </CardContent>
        </Card>,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_creacion",
        keyValue:"fecha_creacion",
        label:"Fecha de creacion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_cierre",
        keyValue:"fecha_cierre",
        label:"Fecha de cierre",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"estado_caso",
        keyValue:"estado_caso",
        label:"Activo",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Chip label={props.value} color={getCestaColor(props.value)} />,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
        {
        key:"editar",
        keyValue:"cod",
        label:"Acciones",
        headerRender:(props)=>props.label,
        bodyRender:({value,info})=><Stack direction={"row"} >
         {/*  <Button size="small" color="success"  variant="contained"  ><Check/></Button> */}
          <Button disabled={info.estado_caso === 'CERRADO'} size="small" color="error" onClick={e=>onShowDetailProduct(info)} variant="contained"  ><Comment/></Button>
        </Stack>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
        
    ];
   
    const configModal =  {
      titleModal: 'Incluir respuesta casos',
      buttomsAction: [
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
     
        {
          key:"descripcion_caso",
          keyValue:"descripcion_caso",
          label:"Descripcion del caso",
          responsiveSize:12,
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            multiline:true,
            minRows:3,
            disabled:true
          }
        },
        {
          key:"respuesta",
          keyValue:"respuesta",
          label:"Respuesta y observacionees",
          responsiveSize:12,
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            multiline:true,
            minRows:3,
          
          }
        },
        {
          key:"estado_caso",
          keyValue:"estado_caso",
          label:"Estado",
          component:SelectInputWithLabel,
          inputProps:{
            size:"small",
            items:[
              {
                value:"ABIERTO",
                label:"Abierto"
              },
              {
                value:"CERRADO",
                label:"Cerrado"
              }
             
            ],
            type:"select",
       
          }
        }
        
      ]
    } ;


  

    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }


   
    <Grid container spacing={2} >

      
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}